import React, { useEffect, useMemo } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useRole } from "../contexts/RoleContext";

interface ExecutorOnlyRouteProps {
  children: React.ReactNode;
}

const ExecutorOnlyRoute: React.FC<ExecutorOnlyRouteProps> = ({ children }) => {
  const { estateId } = useParams<{ estateId: string }>();
  const { activeRole, availableRoles, isLoading, switchRole } = useRole();

  const matchingExecutorRole = useMemo(
    () =>
      availableRoles.find(
        (role) =>
          role.role === "executor" && role.estateOwnerId === estateId
      ),
    [availableRoles, estateId]
  );

  const isActiveExecutorEstate =
    activeRole?.role === "executor" &&
    activeRole.estateOwnerId === estateId;

  useEffect(() => {
    if (!estateId || !matchingExecutorRole || isActiveExecutorEstate) {
      return;
    }

    switchRole(matchingExecutorRole);
  }, [
    estateId,
    matchingExecutorRole,
    isActiveExecutorEstate,
    switchRole,
  ]);

  if (isLoading) {
    return null;
  }

  if (!estateId || !matchingExecutorRole) {
    return <Navigate to="/estate-selector" replace />;
  }

  if (!isActiveExecutorEstate) {
    return null;
  }

  return <>{children}</>;
};

export default ExecutorOnlyRoute;